import ky from 'ky';

export const fetchRemoteAsset = async (url, onProgress) => {
    const progressHandler = (progress) => {
        // const progressPercentage = ((progress.loaded/progress.total) * 100).toFixed(0);
        onProgress(progress.percent * 100);
    }

	// pgw 20-apr-2023
	// Set timeout to 60 seconds (rather than default, which is 10 seconds)

	// pgw 20-may-2025 testing
	// add x-auth-token to call
    const response = {
        data: await ky.get(url, {
      		headers: { 'x-auth-token': 'ef070d40ebf8df00dce0ccd6c753527017eeaf4a70a5b8c952351dcff077cf94' },
            onDownloadProgress: progressHandler,
			timeout: 60000
        }).arrayBuffer()
    }
    return response;
}